import React from "react";
// styled components
import { Modal, Button } from "antd";
// models
interface IProps {
  nombre: string;
  modal: boolean;
  eliminar: any;
  cancelar: any;
  indexExperiencia: number;
}

export const ModalEliminarExperiencia: React.FC<IProps> = (props: IProps) => {
  return (
    <Modal
      className="modal-eliminar-class"
      style={{ top: 50 }}
      visible={props.modal}
      onOk={() => props.eliminar(props.indexExperiencia)}
      onCancel={props.cancelar}
      width={800}
      footer={[
        <Button className="button-gray-ghost" onClick={props.cancelar}>
          CANCELAR
        </Button>,
        <Button className="button-azul-radius" onClick={props.eliminar}>
          ACEPTAR
        </Button>,
      ]}
      maskStyle={{
        backgroundColor: "rgba(31,174,239,0.8)",
      }}
    > 
      <div className="row mt-4">
        <div className="col-12 font-color-DB2828 font-size-22px text-center justify-content-center">
        Se eliminará la educación no formal
        </div>
        <div className="col-12 justify-content-center font-family-Montserrat-Regular font-size-14px">
          Estás a punto de eliminar "{props.nombre}"
        </div>
        <div className="col-12 justify-content-center font-family-Montserrat-Bold font-size-14px">
          ¿Desea eliminarla?
        </div>
      </div>
    </Modal>
  );
};
